import React from 'react';

const FinalCTA: React.FC = () => {
  return (
    <div className="flex flex-col gap-4">
      <p className="font-proxima text-white text-lg lg:text-2xl tracking-[1.2px] leading-normal">
        <span>Get your professional quotation in just</span>
        <span className="font-proxima-bold font-bold"> 3 business days</span>
      </p>
      <p className="font-proxima text-white text-lg lg:text-2xl tracking-[1.2px] leading-normal">
        Our Senior Developers and Business Analysts are ready to turn your vision into reality.
      </p>
      <div className="flex flex-col gap-3 mt-4">
        <a
          href="#get-started"
          className="inline-flex items-center justify-center rounded overflow-hidden bg-white cursor-pointer p-3 lg:p-4 hover:bg-opacity-90 transition-colors w-fit"
        >
          <span className="font-proxima-bold font-bold text-[#4d5ae4] text-base lg:text-2xl leading-6 whitespace-nowrap">
            SUBMIT REQUIREMENTS
          </span>
        </a>
        <div className="font-proxima text-white text-lg lg:text-2xl tracking-[1.2px] leading-normal">
          OR
        </div>
        <a
          href="#get-started"
          className="inline-flex items-center justify-center rounded overflow-hidden bg-white cursor-pointer p-3 lg:p-4 hover:bg-opacity-90 transition-colors w-fit"
        >
          <span className="font-proxima-bold font-bold text-[#4d5ae4] text-base lg:text-2xl leading-6 whitespace-nowrap">
            BOOK A MEETING
          </span>
        </a>
      </div>
    </div>
  );
};

export default FinalCTA;
